import { USERSTATUS, ACCOUNTSTATUS } from './constants'
let cache = {
  [USERSTATUS]: [
    { label: '在职', value: '在职' },
    { label: '离职', value: '离职' }
  ],
  [ACCOUNTSTATUS]: [
    { label: '已开通', value: '已开通' },
    { label: '已停用', value: '已停用' }
  ]
}
function getOptionsByKey(key) {
  return new Promise((resolve) => {
    resolve(cache[key])
  })
}
export function registerOptions(key, array) {
  cache[key] = array
}
export function deteleOptions(key) {
  delete cache[key]
}
export { getOptionsByKey }
